import { useFormContext } from "react-hook-form";

import { FlexBoxRow } from "components/atoms";
import { toDateOnlyLocal } from "helpers/date";
import { useStoreState } from "store/store";

import { SummaryDateItem } from "./SummaryDateItem";

export const SummaryDates = () => {
  // state
  const cart = useStoreState((s) => s.cart);
  const isLocationAirport = useStoreState((s) => s.isLocationAirport);
  const isDestinationAirport = useStoreState((s) => s.isDestinationAirport);
  const nothingIsAirport = !isLocationAirport && !isDestinationAirport;
  const isRoundTrip = cart?.roundtrip;

  // live form values
  const { watch } = useFormContext();
  const bookingDateForm = toDateOnlyLocal(watch("bookingDate"));
  const bookingTimeForm = watch("bookingTime") ?? "";
  const departureDateForm = toDateOnlyLocal(watch("departureDate"));
  const departureTimeForm = watch("departureTime") ?? "";

  // fall back to cart if form is empty
  const bookingDate =
    bookingDateForm ?? toDateOnlyLocal(cart?.booking_date ?? null);
  const bookingTime = bookingTimeForm || cart?.booking_time || "";
  const departureDate =
    departureDateForm ?? toDateOnlyLocal(cart?.departure_date ?? null);
  const departureTime = departureTimeForm || cart?.departure_time || "";

  // convenience (arrival mirrors booking)
  const arrivalDate = bookingDate;
  const arrivalTime = bookingTime;

  if (!bookingDate && !bookingTime && !departureTime && !departureDate)
    return null;

  return (
    <FlexBoxRow
      styleProps={{
        flexWrap: "wrap",
        gap: 4,
        flexDirection: "row",
        marginTop: "24px",
      }}
    >
      {!!bookingDate && !!bookingTime && nothingIsAirport && !isRoundTrip && (
        <SummaryDateItem
          data={{
            date: bookingDate,
            time: bookingTime,
            label: "Arrival",
          }}
        />
      )}

      {((!!arrivalDate && isLocationAirport && !!arrivalTime) ||
        (!!isRoundTrip && !!arrivalDate && !!arrivalTime)) && (
        <SummaryDateItem
          data={{ date: arrivalDate, time: arrivalTime, label: "Arrival" }}
        />
      )}

      {!!departureDate &&
        !!departureTime &&
        (isDestinationAirport || !!isRoundTrip) && (
          <SummaryDateItem
            data={{
              date: departureDate,
              time: departureTime,
              label: "Departure",
            }}
          />
        )}
    </FlexBoxRow>
  );
};
